(function () {
	const addNotification = () => {
		const notification = document.querySelector('.notification');
		const notificationOverlay = document.querySelector('.notification-overlay');
		const timeout = notification.dataset.timeout * 1000;

		let times = notification.dataset.times;
		let notificationShowedTimes = parseInt(localStorage.getItem('notificationCounter') || 0);
		
		const btn = document.querySelector('.notification__btn');

		const hideNotification = () => {
			btn.closest('.notification').classList.add('close');

			if (MOUSE_CURSOR) MOUSE_CURSOR.hide();
		}

		if (btn) {
			btn.addEventListener('click', hideNotification)
		}
		
		if (notificationOverlay) {
			notificationOverlay.addEventListener('click', hideNotification)
		}

		if (notification && notificationShowedTimes < times) {
			setTimeout(() => {
				notification.classList.add('open');
			}, timeout)
			++notificationShowedTimes;
			localStorage.setItem('notificationCounter', notificationShowedTimes);
		}
	}
	document.addEventListener('DOMContentLoaded', addNotification);
	document.addEventListener('shopify:section:load', addNotification);
})();